<template>
  <div>
    <div class="grid grid-cols-1 gap-4 max-h-[60vh] overflow-y-auto">
      <div class="grid grid-cols-2 gap-6 mt-4 px-8">
        <div class="mb-4">
          <label class="font-medium">Appointment Date:</label>
          <input type="date" v-model="radiologyForm.date" placeholder="Type..."
            class="w-full border-gray-300 rounded p-2 bg-gray-50 mt-2" required>
        </div>
        <div class="flex flex-col">
          <label class="font-medium">Appointment Time:</label>
          <div class="relative">
            <div class="absolute inset-y-0 end-0 top-0 flex items-center pe-3.5 pointer-events-none">
              <svg class="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                <path fill-rule="evenodd"
                  d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm11-4a1 1 0 1 0-2 0v4a1 1 0 0 0 .293.707l3 3a1 1 0 0 0 1.414-1.414L13 11.586V8Z"
                  clip-rule="evenodd" />
              </svg>
            </div>
            <input type="time" id="time"
              class="bg-gray-50 border leading-none border-gray-300 text-gray-900 p-2 mt-2 text-md rounded-lg focus:ring-custom-yellowfocus:border-custom-yellow block w-full dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-custom-yellow dark:focus:border-custom-yellow"
              min="09:00" max="18:00" value="00:00" required />
          </div>
        </div>
        <div class="mb-4">
          <label class="font-medium">Referred By:</label>
          <input type="text" v-model="radiologyForm.referred_by" placeholder="Type..."
            class="w-full border-gray-300 rounded p-2 bg-gray-50 mt-2" required>
        </div>
        <div class="mb-4">
          <h3 class="font-medium">Reason for Schedule:</h3>
          <input type="text" v-model="radiologyForm.reason" placeholder="Type..."
            class="w-full border-gray-300 rounded p-2 bg-gray-50 mt-2" required>
        </div>
        <div class="mb-4">
          <h3 class="font-medium">Assigned Radiology/Technician:</h3>
          <input type="text" v-model="radiologyForm.technician" placeholder="Type..."
            class="w-full border-gray-300 rounded p-2 bg-gray-50 mt-2" required>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LabRejectionTab',
  created() {

  },
  data() {
    return {
      radiologyForm: {
        date: '',
        time: '',
        referred_by: '',
        reason: '',
        technician: '',
      },
    }
  },
  props: {

  },
  methods: {

  },
}
</script>

<style lang="scss" scoped></style>
